// extracted by mini-css-extract-plugin
module.exports = {"moreAbout":"moreAbout_moreAbout__yuQ0w","active":"moreAbout_active__AFaaa"};